var map = {
	"./fernando.png": 133,
	"./guitar_l_c.png": 611,
	"./guitar_r_c.png": 273,
	"./icons/facebook_c.png": 644,
	"./icons/instagram_c.png": 345,
	"./icons/spotify_c.png": 962,
	"./icons/twitch_c.png": 556,
	"./icons/youtube_c.png": 957,
	"./logo_c.png": 705,
	"./uziel.png": 577,
	"./wp_c.png": 730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;